<script setup>
import IconosTipoUsuario from '../usuarios/IconosTipoUsuario.vue';

defineProps({
  destinatario: { type: Object, required: true },
  btnEliminar: { type: Boolean, default: true },
});

const emits = defineEmits(['eliminar']);

function eliminar(destinatario) {
  emits('eliminar', destinatario);
}
</script>

<template>
  <div class="destinatario">
    <span class="label label-default">
      <template v-if="!destinatario.usuario">
        <i
          v-tooltip="$t('mensajeria_direccion')"
          class="fas fa-faw fa-university mensajeria_direccion"
        ></i>
        {{ destinatario.nombre }}
      </template>
      <template v-else>
        <IconosTipoUsuario :usuario="destinatario.usuario"></IconosTipoUsuario>
        {{ destinatario.nombre }}
      </template>
      <a
        v-if="btnEliminar"
        class="btn-xs"
        @click.stop.prevent="eliminar(destinatario)"
      >
        <i class="fa fa-lg fa-times"></i>
      </a>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";
.destinatario {
  padding-bottom: 10px;
  margin-right: $margin-xs;

  .label {
    font-weight: normal;
    font-size: 13px;

    .nombre {
      cursor: pointer;
    }
  }
}
</style>
